import request from '@/utils/request'

export function addAgenda(data) {
  return request({
    url: '/admin/addEventAgenda',
    method: 'post',
    data
  })
}

export function getAgendaList(data) {
  return request({
    url: '/admin/getAllEventAgendas/'+data,
    method: 'get'
  })
}

export function updateAgenda(data) {
  return request({
    url: '/admin/updateEventAgendaById',
    method: 'post',
    data
  })
}

export function updateAgendaStatus(data) {
  return request({
    url: '/admin/updateAgendaStatus/',
    method: 'post',
    data
  })
}

export function deleteEventAgenda(data) {
  return request({
    url: '/admin/deleteEventAgenda/'+data,
    method: 'post'
  })
}

export function deleteEventAgendaFile(data) {
  return request({
    url: '/admin/deleteEventAgendaFile/',
    method: 'post',
    data
  })
}
